import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { BtnToggleProps } from '@UI/Buttons/BtnToggle/types/interfaces'

interface BtnToggleOptions {
  props: BtnToggleProps
  onClick: (value: boolean) => void
}

interface BtnToggleReturn {
  checkedValue: ComputedRef<boolean>
  handleClick: () => void
}

export const useBtnToggle = ({ props, onClick }: BtnToggleOptions): BtnToggleReturn => {
  const checkedValue = computed<boolean>(() => props.checked ?? false)

  const handleClick = (): void => {
    if (!props.readonly) {
      onClick(!checkedValue.value)
    }
  }

  return {
    checkedValue,
    handleClick,
  }
}
